import type { TiltScoutEvidence } from "./tilt-scout-types";

export function TiltScoutRelatedNarratives({
  catalysts = [],
  className = "",
}: {
  catalysts?: TiltScoutEvidence[];
  className?: string;
}) {
  const [first, ...rest] = catalysts;
  const overflow = rest.length;

  return (
    <div className={`min-w-0 ${className}`}>
      <button
        type="button"
        className="block text-left text-[9px] uppercase tracking-[0.13em] text-[var(--fintheon-muted)] transition-colors hover:text-[var(--fintheon-accent)] focus-visible:outline-none focus-visible:text-[var(--fintheon-accent)]"
        onClick={() => {
          if (!first) return;
          window.dispatchEvent(
            new CustomEvent("fintheon:riskflow-open-alert", {
              detail: { alertId: first.id.replace(/^riskflow:/, "") },
            }),
          );
        }}
      >
        Recently Related to Narratives
      </button>
      <p className="mt-0.5 text-[10px] leading-snug text-[var(--fintheon-text)]/76">
        {first ? first.title : "No high-score related catalysts yet."}
        {overflow > 0 ? (
          <span className="text-[var(--fintheon-text)]/34">
            {" "}
            &amp; {overflow} more
          </span>
        ) : null}
      </p>
    </div>
  );
}
